import { Button } from '@/components/shadcn/button'
import { SheetWithFormSchema } from '@/components/ui/SheetWithFormSchema'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { TableAction } from '../types-v4'
import { InferFormValues, JsonFormSchemaV2 } from '../../FormComponent/types'

interface TableActionsProps {
  actions?: TableAction[]
  formSchema?: JsonFormSchemaV2
  submitForm: (data: InferFormValues<JsonFormSchemaV2>, options?: { onSuccess?: () => void }) => void
  isSubmitting: boolean
}

export function TableActions({ actions, formSchema, submitForm, isSubmitting }: TableActionsProps) {
  if (!actions) return null

  return (
    <>
      {actions.map((action) => {
        if (!action.visible) return null
        if ((action.type === 'create' || action.id === 'create') /*for backwards compatibility*/ && formSchema) {
          return (
            <SheetWithFormSchema
              key={action.id}
              triggerTooltip="Add an entry"
              wide
              trigger={
                <Button size="icon" variant="outline" className="size-8 rounded-full">
                  <IconPlusOutline className="size-4" />
                </Button>
              }
              schema={formSchema}
              closeOnSuccess
              onSubmit={(data: InferFormValues<typeof formSchema>, onSuccess) => {
                // Call submitForm with the data and pass the onSuccess callback to be executed only on success
                submitForm(data, {
                  onSuccess: () => {
                    if (onSuccess) {
                      onSuccess()
                    }
                  },
                })
              }}
              isSubmitting={isSubmitting}
            />
          )
        }
        return null
      })}
    </>
  )
}
